/**
 * KILLSWITCH STUB (T556). scripts/build-client.mjs resolves `./feedback/host.js`
 * to this file on every build that does not set BOTH ECMB_FEEDBACK_KIOSK=1 and
 * ECMB_TEST_DEPLOY=1 - which is every default build, including production.
 *
 * Because the swap happens at RESOLVE time, nothing the real host imports is
 * ever entered into the module graph: no shell markup, no feedback.css, no
 * widget, no recorder, no modern-screenshot. Nothing here relies on dead-code
 * elimination, and scripts/check-killswitch.mjs grades the BUILT output in both
 * directions so the claim cannot rot.
 *
 * Two vars rather than one, mirroring the site's house rule: a single mis-set
 * variable must not be able to turn a microphone on.
 *
 * The prop shape must match host.tsx or the swap breaks typecheck.
 */
import type { Store } from '../store/store.js';

export function FeedbackHost(_props: { store: Store }) {
  /* capture is off: no markup, no styles, no listeners, no microphone */
  return null;
}
